export default __webpack_public_path__ + "static/media/CreateBackupJobDetails-Snowflake.08980050.png";